import {
  getPaymentErrorMessage,
  isPaymentErrorCode,
  PaymentErrorEnvelope,
} from "../payments/getPaymentErrorMessage";

enum SparkRegistrationErrorCode {
  MISSING_SPARK_ID = "MISSING_SPARK_ID",
  MISSING_AGE = "MISSING_AGE",
  MISSING_GENDER = "MISSING_GENDER",
  SPARK_OVER = "SPARK_OVER",
  EXCEEDS_CAPACITY = "EXCEEDS_CAPACITY",
  NO_SPACE_MEN = "NO_SPACE_MEN",
  NO_SPACE_WOMEN = "NO_SPACE_WOMEN",
  AGE_RESTRICTION = "AGE_RESTRICTION",
  REGISTRATION_NOT_ALLOWED = "REGISTRATION_NOT_ALLOWED",
}
const SparkRegistrationErrorMap: Record<SparkRegistrationErrorCode, string> = {
  [SparkRegistrationErrorCode.MISSING_SPARK_ID]:
    "Something went wrong. Please contact us and reference error code MISSING_SPARK_ID. We will resolve this issue ASAP.",
  [SparkRegistrationErrorCode.MISSING_AGE]:
    "Please enter your birth date before you can register for this event.",
  [SparkRegistrationErrorCode.MISSING_GENDER]:
    "Please enter your gender before you can register for this event.",
  [SparkRegistrationErrorCode.SPARK_OVER]:
    "This event has concluded, but we are always hosting new events. Check the events page to see the events that you can join.",
  [SparkRegistrationErrorCode.EXCEEDS_CAPACITY]:
    "This event is full, but we are always hosting new events. Check the events page to see the events that you can join.",
  [SparkRegistrationErrorCode.NO_SPACE_MEN]:
    "This event is full for men, but we are always hosting new events. Check the events page to see the events that you can join.",
  [SparkRegistrationErrorCode.NO_SPACE_WOMEN]:
    "This event is full for women, but we are always hosting new events. Check the events page to see the events that you can join.",
  [SparkRegistrationErrorCode.AGE_RESTRICTION]:
    "It looks like you don't fall in the age range for this event.",
  [SparkRegistrationErrorCode.REGISTRATION_NOT_ALLOWED]:
    "Registration is not available for this event.",
};
export const getSparkRegistrationErrorMessage = (
  code?: string,
  params?: PaymentErrorEnvelope
) => {
  if (isPaymentErrorCode(code)) {
    return getPaymentErrorMessage(code, params);
  } else if (code && code in SparkRegistrationErrorMap) {
    return SparkRegistrationErrorMap[code as SparkRegistrationErrorCode];
  }
  return "Something went wrong. Please contact us and we will resolve this issue ASAP.";
};
